import React from "react";

export default function WomenClothesIcon(props) {
  return(
      <img src="/Icons/womenClothes.svg" alt="women clothes" {...props}/>
  )
}
